import { render, staticRenderFns } from "./input-files.vue?vue&type=template&id=cc628450&scoped=true&"
import script from "./input-files.vue?vue&type=script&lang=js&"
export * from "./input-files.vue?vue&type=script&lang=js&"
import style0 from "./input-files.vue?vue&type=style&index=0&id=cc628450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc628450",
  null
  
)

export default component.exports